import React from 'react';
import { cvData } from '../mock';

const CV = () => {
  return (
    <div className="min-h-screen bg-off-white py-20 px-6">
      <div className="max-w-5xl mx-auto">
        <div className="mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-charcoal mb-4">
            Curriculum Vitae
          </h1>
          <div className="text-neutral-600">
            <p>{cvData.contact.phone}</p>
            <p>{cvData.contact.email[0]}</p>
          </div>
        </div>

        {/* Education */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-charcoal mb-6 pb-3 border-b-2 border-copper">
            Education
          </h2>
          <div className="space-y-6">
            {cvData.education.map((edu, index) => (
              <div key={index} className="flex flex-col md:flex-row md:gap-8">
                <div className="md:w-40 flex-shrink-0 text-neutral-600 font-medium mb-2 md:mb-0">
                  {edu.year}
                </div>
                <div className="flex-grow">
                  <h3 className="font-semibold text-charcoal text-lg">{edu.degree}</h3>
                  <p className="text-neutral-700">{edu.institution}</p>
                  {edu.location && <p className="text-neutral-600">{edu.location}</p>}
                  {edu.status && <p className="text-burgundy text-sm mt-1">{edu.status}</p>}
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Experience */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-charcoal mb-6 pb-3 border-b-2 border-copper">
            Professional Experience
          </h2>
          <div className="space-y-6">
            {cvData.experience.map((exp, index) => (
              <div key={index} className="flex flex-col md:flex-row md:gap-8">
                <div className="md:w-40 flex-shrink-0 text-neutral-600 font-medium mb-2 md:mb-0">
                  {exp.year}
                </div>
                <div className="flex-grow">
                  <h3 className="font-semibold text-charcoal text-lg">{exp.position}</h3>
                  <p className="text-neutral-700">{exp.organization}</p>
                  <p className="text-neutral-600">{exp.location}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Awards & Honors */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-charcoal mb-6 pb-3 border-b-2 border-copper">
            Awards, Grants & Residencies
          </h2>
          <div className="space-y-6">
            {cvData.awards.map((award, index) => (
              <div key={index} className="flex flex-col md:flex-row md:gap-8">
                <div className="md:w-40 flex-shrink-0 text-neutral-600 font-medium mb-2 md:mb-0">
                  {award.year}
                </div>
                <div className="flex-grow">
                  <h3 className="font-semibold text-charcoal text-lg">{award.title}</h3>
                  {award.description && <p className="text-neutral-700 italic">{award.description}</p>}
                  {award.institution && <p className="text-neutral-700">{award.institution}</p>}
                  {award.venue && <p className="text-neutral-700">{award.venue}</p>}
                  <p className="text-neutral-600">{award.location}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Exhibitions */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-charcoal mb-6 pb-3 border-b-2 border-copper">
            Exhibitions
          </h2>
          <div className="space-y-6">
            {cvData.exhibitions.map((exhibition, index) => (
              <div key={index} className="flex flex-col md:flex-row md:gap-8">
                <div className="md:w-40 flex-shrink-0 text-neutral-600 font-medium mb-2 md:mb-0">
                  {exhibition.year}
                </div>
                <div className="flex-grow">
                  <h3 className="font-semibold text-charcoal text-lg">{exhibition.title}</h3>
                  <p className="text-neutral-700">{exhibition.venue}</p>
                  <p className="text-neutral-600">{exhibition.location}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Collections */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-charcoal mb-6 pb-3 border-b-2 border-copper">
            Collections
          </h2>
          <div className="space-y-4">
            {cvData.collections.map((collection, index) => (
              <div key={index}>
                <p className="font-semibold text-charcoal">{collection.institution}, {collection.location}</p>
                <p className="text-neutral-700 italic">{collection.work}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Professional Organizations */}
        <section>
          <h2 className="text-2xl font-bold text-charcoal mb-6 pb-3 border-b-2 border-copper">
            Professional Organizations
          </h2>
          <div className="space-y-4">
            {cvData.organizations.map((org, index) => (
              <div key={index} className="flex flex-col md:flex-row md:gap-8">
                <div className="md:w-40 flex-shrink-0 text-neutral-600 font-medium mb-2 md:mb-0">
                  {org.year}
                </div>
                <div className="flex-grow">
                  <p className="font-semibold text-charcoal">{org.name}</p>
                  <p className="text-neutral-600">{org.location}</p>
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default CV;